export const buildOrderBoxBody = () => {
    return {
        product: document.getElementById('orderD_box_product').value,
        color: document.getElementById('orderD_box_color').value,
        quantity: document.getElementById('orderD_box_quantity').value,
        q_type: document.getElementById('orderD_box_type_quantity').value,
        price: document.getElementById('orderD_box_price').value,
        section: document.getElementById('orderD_box_section').value,
    }
}

export const buildPrintBoxBody = (tabValue, printBoxBody) => {
    if (tabValue === 0) { // bandeja mt
      return {
        number_reels_mt: printBoxBody.number_reels_mt,
        mt_reel: printBoxBody.mt_reel,
        short: printBoxBody.short,
      };
    } else { // bandeja kg
      return {
        number_reels_kg: printBoxBody.number_reels_kg,
        total_kg: printBoxBody.total_kg,
      };
    }
  };

export const validatePrintBody = (tabValue,printBoxBody,orderDetail) => {
    if(tabValue===0){//validate inputs of mt

        //
       
        if(printBoxBody.number_reels_mt === null || printBoxBody.number_reels_mt === '' || parseInt(printBoxBody.number_reels_mt)<=0){
            throw new Error('Numero de carretes vacio');
        }

        if(printBoxBody.mt_reel === null || printBoxBody.mt_reel === '' || parseInt(printBoxBody.mt_reel)<=0){
            throw new Error('Metros por carrete vacio');
        }

        if(printBoxBody.short === null || printBoxBody.short === '' || parseInt(printBoxBody.short)<0){
            throw new Error('Error en la corta');
        }

        if(parseInt(printBoxBody.mt_reel) <= parseInt(printBoxBody.short)){
            throw new Error('La corta no puede ser mayor, ni igual a la medida por carrete.');
        }

        if(parseInt(printBoxBody.mt_reel) <= parseInt(printBoxBody.short)){
            throw new Error('La corta no puede ser mayor, ni igual a la medida de un carrete. Esto no sería una corta');
        }

        if(printBoxBody.manager === null || printBoxBody.manager === ''){
            throw new Error('Error en el encargado');
        }
    }
    else{//validate inputs of kg

        if(printBoxBody.number_reels_kg === null || printBoxBody.number_reels_kg === '' || parseInt(printBoxBody.number_reels_kg)<=0){
            throw new Error('Numero de carretes vacio');
        }

        if(printBoxBody.total_kg === null || printBoxBody.total_kg === '' || parseInt(printBoxBody.total_kg)<=0){
            throw new Error('Total de kilos vacio');
        }

    }
    
}


export const validateOrderBoxBody = (body) => {
    if(body.product === null || body.product === ''){
        throw new Error('Producto vacío');
    }

    if(body.color === null || body.color === ''){
        throw new Error('Color vacío');
    }

    if(body.quantity === null || body.quantity === ''){
        throw new Error('Quantity vacío');
    }

    if(body.q_type === null || body.q_type === ''){
        throw new Error('Medida vacío');
    }

    if(body.price === null || body.price === ''){
        throw new Error('Precio vacío');
    }
    if(body.section === null || body.section === '' || parseInt(body.section) >= parseInt(body.quantity) || parseInt(body.section) <= 0 ){
        throw new Error('Medida de corte invalida');
    }
}

export const validateOrderDate = (dateStart,dateEnd) => {
    if(dateStart === null || dateStart === ''){
        throw new Error('Fecha inicial vacia');
    }

    if(dateEnd === null || dateEnd === ''){
        throw new Error('Fecha final vacia');
    }

    if(dateStart === dateEnd || dateStart === dateEnd){
        throw new Error('Las fechas no pueden ser iguales');
    }

    if( dateEnd < dateStart){
        throw new Error('La fecha inicial no puede ser mayor a la final ');
    }
}

